module.exports = __webpack_public_path__ + "/images/cover-elige-compact-int.a3203b4.svg";